import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  getValue,
  getString,
  getBoolean,
  ensureInitialized,
} from "firebase/remote-config";

const KEYS = {
  DYNAMIC_SECTIONS: "Web_Delivery_Dynamic_Sections",
  DELIVERY_SECTIONS_ORDER: "Web_Delivery_Screen_Sections",
  Search_Hide_Promo: "search_hide_promo",
  Limited_Tracking_Label: "limited_tracking",
  Show_SubTotal_in_Basket: "MWeb_Show_subtotal_in_Basket",
  Enable_Fresh_Desk: "Enable_Fresh_Desk",
  Show_Delivery_Time_Prompt: "order_time_prompt",
  Install_Incentives: {
    Key: "web_install_incentives_messages",
    Landing_Footer: "footer",
    Delivery_Banner: "inline_section",
    Smart_Banner: "snack_bar",
    Landing_Banner: "banner",
    Title: "title",
    Body: "body",
    Show_New_Smart_Banner: "new_install_snack_bar",
    Show_Landing_Banner:"new_install_landing_banner",
  },
};

type InstallSectionType = "banner" | "inline_section" | "footer" | "snack_bar";

const InstallAppIncentivesDefaultJSON = `{
  "${[KEYS.Install_Incentives.Title + "_EN"]}": "We have something better for you!",
  "${[KEYS.Install_Incentives.Title + "_AR"]}": "عندنا ليك حاجة اجمد",
  "${[KEYS.Install_Incentives.Body + "_EN"]}":"Get the app, order online, and always enjoy some promos!",
  "${[KEYS.Install_Incentives.Body + "_AR"]}": "احصل على التطبيق والاوردر على الانترنت واستمتع بالخصومات!"
}`

// Your web app's Firebase configuration
// testing
// const firebaseConfig = {
//   apiKey: "AIzaSyCiPYq2VlfrKfz6XarW1cFvHLfGfZ4M2_k",
//   authDomain: "elmenus-android-test.firebaseapp.com",
//   databaseURL: "https://elmenus-android-test.firebaseio.com",
//   projectId: "elmenus-android-test",
//   storageBucket: "elmenus-android-test.appspot.com",
//   messagingSenderId: "461625552793",
//   appId: "1:461625552793:web:d6b35ab4a7d59dbba76d08",
// };

// //production
const firebaseConfig = {
  apiKey: "AIzaSyDxFyBs1pO_fbrmp0YASbRHS7cmPaP2QDY",
  authDomain: "iconic-monitor-649.firebaseapp.com",
  databaseURL: "https://iconic-monitor-649.firebaseio.com",
  projectId: "iconic-monitor-649",
  storageBucket: "iconic-monitor-649.appspot.com",
  messagingSenderId: "624762958330",
  appId: "1:624762958330:web:6c241b71490c4c987cb443",
  measurementId: "${config.measurementId}"
};

const firebaseApp = initializeApp(firebaseConfig);

const remoteConfig = getRemoteConfig();

// will fetch remote config each 1sec default value 12 hour
// remoteConfig.settings.minimumFetchIntervalMillis = 1000; // for development
// setting default value till fetch new configs
remoteConfig.defaultConfig = {
  CALL_PROMPT_WEB: `{
      "REST_OFFLINE": {
        "TITLE_EN": "We have something better for you!",
        "TITLE_AR": "عندنا ليك حاجة اجمد",
        "DESC_EN": "Get the app, order online, and always enjoy some promos!",
        "DESC_AR": "ابلكيشن المنيوز عليه عروض كتير"
      },
      "REST_ONLINE": {
        "TITLE_EN": "We have something better for you!",
        "TITLE_AR": "عندنا ليك حاجة اجمد",
        "DESC_EN": "Get the app, order online, and always enjoy some promos!",
        "DESC_AR": "ابلكيشن المنيوز عليه عروض كتير"
      },
      "REST_ONLINE_HAS_OFFER": {
        "TITLE_EN": "We have something better for you!",
        "TITLE_AR": "عندنا ليك حاجة اجمد",
        "DESC_EN": "Get the app, order online, and always enjoy some promos!",
        "DESC_AR": "اوردر اونلاين واستفيد بالخصم"
      },
      "CALL_ELMENUS_EN": "Call elmenus", 
      "CALL_ELMENUS_AR": "كلم المنيوز", 
      "CALL_RESTAURANT_EN": "Call Restaurant", 
      "CALL_RESTAURANT_AR": "مليش في العروض، هكلم المطعم",
      "DOWNLOAD_APP_EN": "Download the app",
      "DOWNLOAD_APP_AR": "يللا بينا! نزل الابلكيشن"
    }`,
  Cancel_Button_Web: `true`,
  Cancel_Order_Message_Description_Web_EN:
    "Sorry, we are unable to cancel your order as the restaurant already started cooking it. 😞",
  Cancel_Order_Message_Description_Web_AR:
    "احنا آسفين، احنا مش هنقدر نلغي الاوردر لان المطعم ابتدي يجهزه. 😞",
  Split_Wallet_View1_Web: `true`,
  Split_Wallet_View2_Web: `false`,
  Split_Wallet_View3_Web: `false`,
  Payment_Summary_Title_AR: "ملخص الأوردر",
  Payment_Summary_Title_EN: "Order Summary",
  WEB_SHOW_DRIVER_DETAILS: "OUT_FOR_DELIVERY",
  WEB_SHOW_DRIVER_PIN: `false`,
  Show_Topup: `false`,
  Topup_Credit_Title_EN: `Add new credit card`,
  Topup_Credit_Title_AR: `أضف كارد جديد`,
  Topup_Wallet_Amount_Title_EN: `Top up your wallet`,
  Topup_Wallet_Amount_Title_AR: `اشحن محفظتك`,
  [KEYS.Limited_Tracking_Label]: `false`,
  Show_info_delivery: `false`,
  Show_info_service: `false`,
  Message_info_delivery_EN:
    "Wohoo! elmenus reduced their delivery fees based on your zone location 😉. Our main goal is to offer you the best convenient service.",
  Message_info_delivery_AR:
    "تخفيض رسوم التوصيل من المنيوز و سيتم حساب سعر التوصيل بناءا على منطقتك ! المنيوز دائما تسعي لتقديم احسن خدمه لكل عملائها",
  Message_info_service_EN:
    "elmenus upgraded their service and quality to deliver you a better experience by introducing the service fees.The service fees will be 5% of the sub-total price of your order and will be applied before any discounts and is capped at 22.49 EGP with a minimum of 2.49 EGP.",
  Message_info_service_AR:
    "المنيوز تسعي لتطوير خدماتها لرضاء العملاء و تقديم خدمة عالية الجودة لذلك تم تطبيق رسوم الخدمة ٥٪ من اجمالي سعر الآوردر قبل اضافه الخصومات و الضريبه بحد أقصى 22.49 ج.م و حد أدنى 2.49 ج.م",
  [KEYS.Show_SubTotal_in_Basket]: `false`,
  [KEYS.Enable_Fresh_Desk]: `false`,
  [KEYS.Show_Delivery_Time_Prompt]: `false`,
  [KEYS.Install_Incentives.Key]: `{
    "${[KEYS.Install_Incentives.Landing_Footer]}": ${InstallAppIncentivesDefaultJSON},
    "${[KEYS.Install_Incentives.Delivery_Banner]}": ${InstallAppIncentivesDefaultJSON},
    "${[KEYS.Install_Incentives.Smart_Banner]}": ${InstallAppIncentivesDefaultJSON},
    "${[KEYS.Install_Incentives.Landing_Banner]}": ${InstallAppIncentivesDefaultJSON}
  }`,
  [KEYS.Install_Incentives.Show_New_Smart_Banner]: `false`
};

const getRemoteConfigAsString = (key) => getString(remoteConfig, key);
const getRemoteConfigAsBoolean = (key) => getBoolean(remoteConfig, key);
const getRemoteConfigValue = (key) => getValue(remoteConfig, key);
const ensureRemoteConfigInitialize = () => {
  return ensureInitialized(remoteConfig);
};

export {
  firebaseApp,
  remoteConfig,
  getRemoteConfigAsBoolean,
  getRemoteConfigAsString,
  getRemoteConfigValue,
  ensureRemoteConfigInitialize,
  KEYS,
  InstallSectionType
};
